import { MenuProps, Tooltip } from 'antd';
import { Button, Dropdown } from 'antd';
import {
  DeleteOutlined,
  ExclamationCircleFilled,
  FieldTimeOutlined,
  MoreOutlined,
} from '@ant-design/icons';
import { Scene } from '@monorepo/types';
import React, { FunctionComponent, useRef } from 'react';
import { useVideoContext } from '../../../../hooks/use-video';
import { useConfirm } from '../../../../hooks';
import UpdateSceneDurationModal, {
  UpdateSceneDurationModalActions,
} from './update-scene-duration-modal';
import { useTranslation } from 'react-i18next';

interface Props {
  scene: Scene;
}

const SceneActions: FunctionComponent<Props> = ({ scene }) => {
  const { t } = useTranslation();
  const { deleteScene, editSceneDuration } = useVideoContext();
  const { confirm } = useConfirm();
  const modalRef = useRef<UpdateSceneDurationModalActions>(null);

  const handleDelete = async () => {
    try {
      confirm({
        title: t('videoEditor.scene.deleteConfirm.title'),
        icon: <ExclamationCircleFilled />,
        okText: t('videoEditor.scene.deleteConfirm.ok'),
        okType: 'danger',
        onOk: async () => {
          await deleteScene({
            sceneId: scene._id,
          });

          console.log('Deleted successfully');
        },
      });
    } catch (e) {
      console.error('Failed to delete scene:', e);
    }
  };

  const handleEditDuration = async () => {
    modalRef.current?.open();
  };

  const items: MenuProps['items'] = [
    {
      key: 'edit-duration',
      label: t('videoEditor.scene.actions.editDuration'),
      icon: <FieldTimeOutlined />,
      onClick: handleEditDuration,
    },
    {
      key: 'delete',
      label: t('videoEditor.scene.actions.delete'),
      icon: <DeleteOutlined />,
      onClick: handleDelete,
    },
  ];

  return (
    <>
      <Dropdown menu={{ items }} placement="bottomRight" trigger={['click']}>
        <Tooltip
          placement={'top'}
          title={t('videoEditor.scene.actions.sceneActions')}
        >
          <Button type="text" size="middle" icon={<MoreOutlined />} />
        </Tooltip>
      </Dropdown>
      <UpdateSceneDurationModal ref={modalRef} scene={scene} />
    </>
  );
};

export default SceneActions;
